import { useMutation } from "react-query";
import { LotteInstance } from "../instance";

// 롯데 운송장관리 화면에서 연계일보 정보를 서버 기준으로 갱신한다.
export const useRefreshLotteCarInfo = () =>
  useMutation(() =>
    LotteInstance.post("/carinfo_refresh", {
      api: "carinfo",
    }),
  );
